import { NativeSelectProps } from "@material-ui/core/NativeSelect";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import React, { useEffect, useState } from "react";

import { StyledGrid } from "components/simple";
import { StyledSelect } from "./styled";

interface CustomProps {
  callback?: React.Dispatch<string | number>;
  defaultText: string;
  disabled?: boolean;
  options: Record<string, number>[];
  selectedValue?: number;
}

type ScoreSelectProps = CustomProps & NativeSelectProps;

const ScoreSelect: React.FC<ScoreSelectProps> = ({
  callback,
  defaultText,
  disabled = false,
  options,
  selectedValue,
  ...otherProps
}: ScoreSelectProps) => {
  const [value, setValue] = useState<string>();

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
    const value = event.target.value;

    setValue(value);

    if (callback) {
      callback(value);
    }
  };

  useEffect(() => {
    setValue(selectedValue === undefined ? "" : String(selectedValue));
  }, [selectedValue]);

  return (
    <StyledGrid container alignItems={"center"}>
      <StyledSelect
        disabled={disabled}
        IconComponent={ArrowDropDownIcon}
        value={value}
        variant="outlined"
        onChange={handleChange}
        {...otherProps}
      >
        <option value={""} disabled>
          {defaultText}
        </option>
        {options.map((option: Record<string, number>) => {
          const keyString = Object.keys(option)[0];
          const valueNumber = option[keyString];
          return (
            <option key={valueNumber} value={valueNumber}>
              {keyString}
            </option>
          );
        })}
      </StyledSelect>
    </StyledGrid>
  );
};

export default ScoreSelect;
